/* A/B test "preorder-sale-framing".
 *
 * TEST arm: the preorder sale treatment is visible, i.e. the full-bleed banner
 * on both templates, the ribbon fused to the selected configuration card, and
 * the struck-through anchor prices beside the real ones.
 * CONTROL arm: none of it renders. Prices read as plain $69 / $89.
 *
 * Only the sale framing varies. The ember colourway, the warm selected-card
 * wash and the chip order are in BOTH arms, so the test measures the discount
 * messaging rather than a pile of unrelated design changes.
 *
 * The markup is always server-rendered but hidden in CSS; this adds
 * rk-ab-sale-on to each .rk-root to reveal it. Hidden-by-default means a
 * PostHog outage, an ad blocker, or a slow flag response all fail safe to
 * CONTROL, so a discount claim is never shown to a visitor we cannot bucket.
 *
 * The class goes on .rk-root rather than <html> so the section can switch the
 * TEST arm on server-side in the theme editor (see request.design_mode), and
 * so the landing page's embedded-PDP test inherits it: that variant injects
 * the PDP inside the already-classed root, so the descendant selectors match
 * without this script needing to re-run.
 *
 * QA override: ?rk_sale=1 forces TEST, ?rk_sale=0 forces CONTROL.
 */
(function () {
  var FLAG = 'preorder-sale-framing';
  var ON_CLASS = 'rk-ab-sale-on';

  function activateTest() {
    var roots = document.querySelectorAll('.rk-root');
    for (var i = 0; i < roots.length; i++) {
      roots[i].classList.add(ON_CLASS);
    }
  }

  // QA override, independent of PostHog.
  try {
    var forced = new URLSearchParams(location.search).get('rk_sale');
    if (forced === '1') { activateTest(); return; }
    if (forced === '0') { return; }
  } catch (e) {}

  // PostHog-bucketed. Calling getFeatureFlag inside onFeatureFlags records the
  // experiment exposure. Give up after 3s (stay control) so the sale can never
  // pop in after the visitor has already read the price.
  if (!window.posthog || !posthog.onFeatureFlags) { return; }
  var handled = false;
  var giveUp = setTimeout(function () { handled = true; }, 3000);
  posthog.onFeatureFlags(function () {
    if (handled) { return; }
    handled = true;
    clearTimeout(giveUp);
    try {
      if (posthog.getFeatureFlag(FLAG) === 'test') { activateTest(); }
    } catch (e) {}
  });
})();
